import { render, staticRenderFns } from "./ReportProductsCardex.vue?vue&type=template&id=3c994867"
import script from "./ReportProductsCardex.vue?vue&type=script&lang=js"
export * from "./ReportProductsCardex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports